import { connectHook } from '../../connect-hook';
import { SingleLineTextWidget } from './single-line-text';
import { type SingleLineTextWidgetOwnProps, useSingleLineText } from './single-line-text-hook';

export type SingleLineTextWidgetProps = SingleLineTextWidgetOwnProps;

export default connectHook(SingleLineTextWidget, useSingleLineText);
